<template>
  <div class="admin-container">
    <template>
      <v-row>
        <v-col cols="12" md="12">
          <v-btn
            tile
            small
            @click="
              $router.push({
                name: 'ConstructionDiary',
              })
            "
            >Zpět</v-btn
          >
        </v-col>
      </v-row>
      <h3 class="mt-5 mb-8 col-secodary-2">Nový záznam deníku</h3>
      <v-row>
        <v-col cols="12" md="3"
          ><v-text-field
            v-model="data.name"
            label="Název záznamu *"
          ></v-text-field
        ></v-col>
        <v-col cols="12" md="3">
          <DatePicker
            label="Termín záznamu *"
            @dateChanged="changeDate($event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3"
          ><v-select
            :items="timelines"
            v-model="data.timeline_id"
            label="Přiřadit k etapě *"
            item-text="name"
            item-value="id"
          ></v-select
        ></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-textarea
            v-model="data.note"
            label="Poznámka"
            auto-grow
          ></v-textarea>
        </v-col>
      </v-row>

      <input
        style="display: none"
        ref="documentFile"
        type="file"
        class="input--file"
        multiple
        @input="handleInputFile($event.target.files)"
      />
      <div
        class="d-flex flex-column flex-md-row align-center align-md-start doc-wrapper"
      >
        <div
          v-for="(document, documentIdx) in documents"
          :key="document.document_id"
        >
          <div class="document-added mr-md-6">
            <div
              class="document-document-mini"
              :style="correctIcon(document)"
            ></div>
            <div class="document-extension">
              {{ document.extension ? document.extension.toUpperCase() : '' }}
            </div>
            <div class="document-text document-text--overflow mt-2"></div>
            <div class="document-close">
              <button
                @click="handleDeleteFile(document.document_id, documentIdx)"
              >
                <img :src="require('@/assets/zavrit.svg')" alt="" />
              </button>
            </div>
          </div>
          <v-text-field
            style="width: 150px"
            v-model="document.document_name"
            label="Název souboru *"
          ></v-text-field>
        </div>

        <button class="document-input-add" @click="handleClick('documentFile')">
          <div class="document-input-add-plus">+</div>
          <div class="document-input-add-text">Vložit dokument</div>
        </button>
      </div>
      <v-row>
        <v-col cols="12" md="3"></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3"></v-col>
      </v-row>
      <v-row class="mt-8">
        <v-col class="text-right">
          <v-btn
            small
            tile
            color="secondary"
            class="mr-4"
            @click="
              $router.push({
                name: 'ConstructionDiary',
              })
            "
            >Zrušit</v-btn
          >
          <v-btn small tile color="primary" @click="store">Uložit</v-btn>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import bus from '../plugins/bus';
import authHandler from '../api/authHandler';
import permissionDenied from '../api/permissionDenied';
import projectingSubdirectoryService from '../api/projectingSubdirectoryService';
import errorHandler from '../api/errorHandler';
import documentService from '../api/documentService';
import projectingDocumentService from '../api/projectingDocumentService';
import timelineService from '../api/timelineService';
import constructionDiaryService from '../api/constructionDiaryService';
import DatePicker from '../components/DatePicker';
const IMAGES_EXT = ['jpg', 'jpeg', 'svg', 'png'];
const PDF = 'pdf';
const ZIP = 'zip';
const PPT = 'ppt';
const XLS = 'xls';

export default {
  data() {
    return {
      data: {},
      documents: [],
      timelines: [],
    };
  },
  components: {
    DatePicker,
  },
  async created() {
    permissionDenied(
      this.user,
      this.$router,
      'SUPERUSER',
      'PROJECT_MANAGER',
      'MAIN_SUPERUSER',
      'MAIN_PROJECT_MANAGER'
    );
    bus.$emit('processing');
    await this.indexTimelines();
    bus.$emit('processing', false);
  },
  methods: {
    correctIcon(doc) {
      let icon = 'document.svg';
      if (IMAGES_EXT.includes(doc.extension)) icon = 'jpg.svg';
      if (PDF == doc.extension) icon = 'pdf.svg';
      if (doc.extension.includes(ZIP)) icon = 'zip.svg';
      if (doc.extension.includes(PPT)) icon = 'ppt.svg';
      if (doc.extension.includes(XLS)) icon = 'xls.svg';
      return {
        backgroundImage: `url(${require('@/assets/' + icon)})`,
      };
    },
    changeDate(v) {
      this.data.date_of_record = v;
    },
    async handleDeleteFile(documentId, documentIdx) {
      try {
        bus.$emit('processing');
        await documentService._delete(documentId);
        this.documents.splice(documentIdx, 1);
        bus.$emit('processing', false);
      } catch (error) {
        bus.$emit('processing', false);
        console.error(error);
        errorHandler(error);
      }
    },
    handleClick(ref) {
      this.$refs[ref].click();
    },
    async handleInputFile(f) {
      try {
        console.debug(f);
        bus.$emit('processing');
        for (let fidx = 0; fidx < f.length; fidx++) {
          const { data } = await documentService.store(f[fidx]);
          this.documents.push({
            document_id: data.id,
            document_name: data.client_name,
            mimetype: data.mimetype,
            mime: data.mime,
            extension: data.extension,
          });
        }
        bus.$emit('processing', false);
        bus.$emit('snackbar', {
          text: `Podařilo se nahrát dokumenty`,
          color: 'info',
        });
        this.$refs.documentFile.values = [];
      } catch (error) {
        bus.$emit('processing', false);
        console.error(error);
        errorHandler(error);
      }
    },
    async indexTimelines() {
      try {
        const data = await timelineService.index();
        this.timelines = data;
      } catch (error) {
        console.error(error);
        errorHandler(error);
      }
    },
    async store() {
      try {
        bus.$emit('processing');
        const response = await constructionDiaryService.store({
          ...this.data,
          documents: this.documents,
        });
        console.debug('Response', response);
        bus.$emit('processing', false);
        bus.$emit('snackbar', {
          text: 'Uloženo',
          color: 'success',
        });
        this.$router.push({
          name: 'ConstructionDiary',
        });
      } catch (error) {
        console.error(error);
        bus.$emit('processing', false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.error.message
        ) {
          bus.$emit('snackbar', {
            text: error.response.data.error.message,
            color: 'error',
          });
        }
      }
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  watch: {},
};
</script>

<style></style>
